'use strict';

var planValidGlobalDefaults = {
  // Language ['es' (Español) || 'pt' (Portugués)]
  lang: 'es',
  // Market ['pyb' (Península y Baleares) || 'can' (Canarias) || 'pt' (Portugal)]
  market: 'pyb',
  // Type of form [1 (Private persons) || 2 (Companies and Self-employed)]
  type: 1,
  // Set to true if there is a Dealer field to validate
  fieldDealer: false,
  fieldModel: false,
  fieldMotor: false,
  // Element error tag for jQuery.validator
  errorElement: 'span',
  // Error class for jQuery.validator
  errorClass: 'error',
  // Error Placement for jQuery.validator
  errorPlacement: function errorPlacement(error, element) {
    if (element.hasClass('js-field-userType')) {
      $('#userType-error').append(error);
    } else {
      element.after(error);
    }
  },
  // Event submit handler for jQuery.validator
  submitHandler: function submitHandler(form) {
    form.submit();
  },
  // Texts for translate labels and jQuery.validator error messages
  texts: {
    es: {
      labels: {
        name: 'NOMBRE',
        surname1: 'PRIMER APELLIDO',
        surname2: 'SEGUNDO APELLIDO',
        cp: 'CÓDIGO POSTAL',
        phone: 'TELÉFONO',
        email: 'E-MAIL',
        submit: 'ENVIAR',
        selfemployed: 'AUTÓNOMO',
        company: 'EMPRESA',
        position: 'CARGO EN LA EMPRESA',
        companyName: 'RAZÓN SOCIAL DE LA EMPRESA',
        nif: 'NIF/NIE',
        cif: 'CIF',
        fleetSize: 'TAMAÑO DE LA FLOTA',
        select: 'Selecciona'
      },
      errors: {
        required: 'Campo obligatorio',
        cp: 'Código Postal incorrecto',
        phone: 'Teléfono incorrecto',
        email: 'E-mail incorrecto',
        alphabetical: 'Sólo caracteres alfabéticos',
        nifNie: 'NIF/NIE incorrecto',
        cif: 'CIF incorrecto',
        dealer: 'Selecciona un concesionario',
        model: 'Selecciona un modelo',
        motor: 'Selecciona un motor',
        noConsecutiveLetters: 'No se permiten 3 letras iguales consecutivas',
        noSpecialCharacters: 'No se permiten caracteres especiales',
        miniumOneVocal: 'Tiene que contener al menos una vocal',
        min3characters: 'Introduzca mínimo 3 caracteres'
      }
    },
    pt: {
      labels: {
        name: 'NOME',
        surname1: 'APELIDO',
        surname2: 'SEGUNDO APELIDO',
        cp: 'CÓDIGO POSTAL',
        phone: 'TELEFONE',
        email: 'E-MAIL',
        submit: 'ENVIAR',
        selfemployed: 'INDEPENDENTE',
        company: 'EMPRESA',
        position: 'CARGO NA EMPRESA',
        companyName: 'RAZÃO SOCIAL DA EMPRESA',
        nif: 'CARTÃO DE CIDADÃO / BILHETE DE IDENTIDADE',
        cif: 'NIPC',
        fleetSize: 'TAMANHO DA FROTA',
        select: 'Seleccione'
      },
      errors: {
        required: 'Campo obrigatório',
        cp: 'Código Postal inválido',
        phone: 'Telefone inválido',
        email: 'E-mail inválido',
        alphabetical: 'Apenas caracteres alfabéticos',
        ccOrBi: 'Cartão de Cidadão inválido',
        nipc: 'NIPC inválido',
        dealer: 'Selecione um concessionário',
        model: 'Selecione um modelo',
        motor: 'Selecione um motor',
        noConsecutiveLetters: '3 cartas consecutivas idênticas não são permitidas',
        noSpecialCharacters: 'Não são permitidos caracteres especiais',
        miniumOneVocal: 'Deve conter pelo menos uma vogal',
        min3characters: 'Introduzir pelo menos 3 caracteres'
      }
    }
  },
  agree: {
    trigger: '.js-trigger-agree',
    target: '.js-target-agree'
  }
};